import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Icon from '../../../utils/svg';

import { changeForm, doLogin, isEnter } from './login.action';

import Background from '../../../assets/img/bg-login.jpg';
import LogoFebracis from '../../../assets/img/logo-febracis.png';
import Button from '../../components/button/button';
import './login.css';

class Login extends Component {

  render() {
    const { form, requesting, disable } = this.props.login;
    if (this.props.auth.token) {
      return < Redirect to='/dashboard' />
    }
    return (
      <section className='login-container' style={{ backgroundImage: `url(${Background})` }}>

        <div className='login-content'>

          <img src={LogoFebracis} />

          <form className='login-form'>

            <div className='login-input'>
              <Icon name='icon-user' height={'25px'} color={'#ACACAE'} />
              <input onChange={this.props.changeForm} value={form.username ? form.username : ''} id='username' type="email" className='textField' placeholder="Usuário" autoComplete='off'/>
            </div>

            <div className='login-input'>
              <Icon name='icon-password' height={'25px'} color={'#ACACAE'} />
              <input onKeyDown={this.props.isEnter} onChange={this.props.changeForm} value={form.password ? form.password : ''} id='password' type="password" className='textField' placeholder="Senha" autoComplete='off'/>
            </div>

          </form>

          <Button onClick={this.props.doLogin} disabled={disable} text='Entrar' iconName='loading' showIcon={requesting} />

        </div>

      </section>
    );
  }
}

const mapStateToProps = ({ login, auth }) => ({ login, auth })

export default connect(mapStateToProps, { changeForm, doLogin, isEnter })(Login);



// WEBPACK FOOTER //
// ./src/App/containers/login/login.js